// src/pages/Login.js
import React, { useState } from 'react';
import { login } from '../api';

export default function Login({ onLogin, error }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError(null);
    try {
      await login(username, password);
      onLogin();
    } catch (err) {
      setLocalError('Login failed. Check username and password.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        className="bg-white p-6 rounded-xl shadow space-y-4 w-80"
        onSubmit={handleSubmit}
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Dashboard Login</h2>
        {(error || localError) && (
          <div className="bg-red-100 text-red-800 px-2 py-1 rounded">
            {error || localError}
          </div>
        )}
        <input
          className="w-full p-2 border rounded"
          type="text"
          placeholder="Username"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          className="w-full p-2 border rounded"
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button
          className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded p-2 mt-2"
          type="submit"
        >
          Log In
        </button>
      </form>
    </div>
  );
}
